import React, { useState } from 'react';
import api from "../tbrosApi.js"
// import ReactLoading from 'react-loading';


const FileUploader = props => {
  const path = props.path
  const filename = props.filename
  const uploaded = props.uploaded
  const beforeUpload = props.beforeUpload
  const validation = props.validation
  const operations = props.operations
  const maxSize = props.maxSize
  const overSizeMessage = props.overSizeMessage
  const onlyImage = props.onlyImage || false
  const hiddenFileInput = React.useRef(null);
  const setLoading = props.setLoading

  const uploadImage = async (file, filename, path, uploaded) => {

    const formData = new FormData();

    formData.append('image', file);

    if (path.startsWith("/")) {
      path = path.substr(1)
    }

    try {
      const url = `/toast/images?path=${path}&id=${filename}`
        + (operations && (`&operations=` + operations) || '')
      const response = await api.postLong(url, formData)
      const fileInfo = response.data
      const imageExt = fileInfo.url.match(/\.[a-zA-Z]+$/)?.shift()
      const imageUrlBeforeExt = fileInfo.url.replace(imageExt, '')
      const operationUrls = operations && imageExt && operations.split(",").map(operation => {
        return (imageUrlBeforeExt + "_" + operation + imageExt) || ''
      })
      await uploaded({
        ...response.data,
        fileName: file.name,
        operationUrls: operationUrls,
      })
    } finally {
    }
  }

  const uploadFile = async (file, filename, path, uploaded) => {
    const formData = new FormData();

    formData.append('file', file);

    if (!path.startsWith("/")) {
      path = "/" + path
    }

    try {
      setLoading?.(true)
      const response = await api.postLong(`/toast/object-storage?path=${path}&filename=${filename}`, formData)
      await uploaded({ ...response.data, fileName: file.name })
    } finally {
      setLoading?.(false)
    }
  }


  const handleClick = event => {
    if (validation && !validation()) {
      return;
    }
    if (beforeUpload) beforeUpload(event)
    hiddenFileInput.current.click();
  };

  const handleChange = event => {
    if (!event || !event.target || event.target.files.length == 0)
      return
    const file = event.target.files[0];
    if (maxSize) {
      if (file.size > maxSize) {
        alert(overSizeMessage || '파일 용량이 너무 큽니다.')
        hiddenFileInput.value = ''
        return
      }
    }
    if (file.type.startsWith("image")) {
      uploadImage(file, filename, path, uploaded)
    } else {
      uploadFile(file, filename, path, uploaded)
    }
  };
  return (
    <>
      <div onClick={handleClick} className={''}>
        {props.children}
      </div>
      {/* {loading && <ReactLoading color='#333' type='bubbles' />} */}
      <input
        type="file"
        ref={hiddenFileInput}
        accept={onlyImage ? "image/png, image/gif, image/jpeg" : ""}
        onChange={handleChange}
        className="hidden" />
    </>
  );
}
export default FileUploader